import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgGridModule } from 'ag-grid-angular';
import { NgxSpinnerModule } from 'ngx-spinner';

import { EmployeeRoutingModule } from './employee-routing.module';
import { EmployeeListComponent } from './employee-list/employee-list.component';
import { EmployeeDetailComponent } from './employee-detail/employee-detail.component';
import { GeneralDataTabComponent } from './employee-detail/tabs/general-data-tab/general-data-tab.component';
import { SalaryTabComponent } from './employee-detail/tabs/salary-tab/salary-tab.component';
import { PersonalDataTabComponent } from './employee-detail/tabs/personal-data-tab/personal-data-tab.component';
import { HealthTabComponent } from './employee-detail/tabs/health-tab/health-tab.component';
import { FiscalTabComponent } from './employee-detail/tabs/fiscal-tab/fiscal-tab.component';
import { ImssTabComponent } from './employee-detail/tabs/imss-tab/imss-tab.component';
import { TerminationModalComponent } from './termination-modal/termination-modal.component';
import { PayrollListComponent } from './payroll-list/payroll-list.component';
import { PayrollDetailComponent } from './payroll-detail/payroll-detail.component';
import { SalaryHistoryTabComponent } from './employee-detail/tabs/salary-history-tab/salary-history-tab.component';
import { HistoryTabComponent } from './employee-detail/tabs/history-tab/history-tab.component';
import { InfonavitCreditTabComponent } from './employee-detail/tabs/infonavit-credit-tab/infonavit-credit-tab.component';
import { IncidentsComponent } from './incidents/incidents.component';
import { PayrollReceiptsListComponent } from './payroll-receipts-list/payroll-receipts-list.component';
import { EmployeeDocumentViewComponent } from './employee-document-view/employee-document-view.component';
import { PayrollConfigComponent } from './payroll-config/payroll-config.component';
import { PayrollPeriodsListComponent } from './payroll-periods-list/payroll-periods-list.component';
import { CierreNominaModalComponent } from './cierre-nomina-modal/cierre-nomina-modal.component';
import { PayrollPeriodReceiptsComponent } from './payroll-period-receipts/payroll-period-receipts.component';
import { StampWizardModalComponent } from './stamp-wizard-modal/stamp-wizard-modal.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    declarations: [
        EmployeeListComponent,
        EmployeeDetailComponent,
        GeneralDataTabComponent,
        SalaryTabComponent,
        PersonalDataTabComponent,
        HealthTabComponent,
        FiscalTabComponent,
        ImssTabComponent,
        TerminationModalComponent,
        PayrollListComponent,
        PayrollDetailComponent,
        SalaryHistoryTabComponent,
        HistoryTabComponent,
        InfonavitCreditTabComponent,
        IncidentsComponent,
        PayrollReceiptsListComponent,
        EmployeeDocumentViewComponent,
        PayrollConfigComponent,
        PayrollPeriodsListComponent,
        CierreNominaModalComponent,
        PayrollPeriodReceiptsComponent,
        StampWizardModalComponent
    ],
    imports: [
        CommonModule,
        EmployeeRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        BrowserAnimationsModule,
        NgxSpinnerModule,
        AgGridModule,
        SharedModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EmployeeModule { }
